import { useMemo } from 'react'
import { PhantomTypeArgument, PositionConfigInfo } from '@kunalabs-io/kai'
import { TypeArgument } from '../../gen/_framework/reified'
import { useObjectDataBatch } from '../../hooks/batshitObjectFetcher'
import { PriceInfoObject as PriceInfoObject_ } from '../../gen/pyth/price-info/structs'
import { PriceInfoObject } from '@kunalabs-io/kai'

export const usePio = (configInfo?: PositionConfigInfo<string, string, TypeArgument>) => {
  const pioRes = useObjectDataBatch(
    [
      {
        id: configInfo!.pioInfoX.priceInfoObjectId,
        fromBcs: PriceInfoObject_.r.fromBcs,
      },
      {
        id: configInfo!.pioInfoY.priceInfoObjectId,
        fromBcs: PriceInfoObject_.r.fromBcs,
      },
    ],
    {
      refetchInterval: 30_000,
      enabled: !!configInfo,
    }
  )

  const [pioX, pioY] = useMemo(() => {
    if (!pioRes || !configInfo) {
      return [undefined, undefined]
    }
    let pioX: PriceInfoObject<PhantomTypeArgument> | undefined
    if (!pioRes[0].data) {
      console.error(
        `Error fetching PrinceInfoObject ${configInfo.pioInfoX.priceInfoObjectId}: ${pioRes[0].error}`
      )
    } else {
      pioX = new PriceInfoObject(pioRes[0].data, configInfo.pioInfoX.T)
    }
    let pioY: PriceInfoObject<PhantomTypeArgument> | undefined
    if (!pioRes[1].data) {
      console.error(
        `Error fetching PrinceInfoObject ${configInfo.pioInfoY.priceInfoObjectId}: ${pioRes[1].error}`
      )
    } else {
      pioY = new PriceInfoObject(pioRes[1].data, configInfo.pioInfoY.T)
    }

    return [pioX, pioY]
  }, [pioRes, configInfo])

  return {
    pioX,
    pioY,
  }
}
